import React from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Images } from "../../../utils/Images";

const DonateLeftBanner = () => {
  const theme = useTheme();
  // Custom media query for screens 900px to 1200px
  const isMediumScreen = useMediaQuery(
    "(min-width: 900px) and (max-width: 1200px)"
  );
  // Custom media query for screens below 900px
  const isSmallScreen = useMediaQuery("(max-width: 899px)");
  const isAbove1200 = useMediaQuery("(min-width: 1200px)");
  // Custom media query for mobile screens (600px and below)
  const isMobile = useMediaQuery("(max-width: 600px)");

  return (
    <Box
      sx={{
        background: "#1D1D1B",
        color: "#fff",
        borderRadius: isMobile ? "20px" : "20px",
        minHeight: isMobile ? "320px" : "100%",
        display:isSmallScreen ? "none" : "flex",
        justifyContent: "space-between",
        position: "relative",
        overflow: "hidden",
        width: isMediumScreen ? "441px" : "541px",
      }}
    >
      <img
        src={Images.donateLeftIcon1}
        alt="Orange Sparks"
        style={{
          position: "absolute",
          top: isMobile ? "10px" : "30px",
          left: isMobile ? "10px" : "50px",
          width: isMobile ? "19px" : "19px",
          height: "auto",
          zIndex: 1,
          display: isMobile ? "none" : "block", // Hide on mobile
        }}
      />
      <img
        src={Images.donateLeftIcon2}
        alt="Orange Sparks"
        style={{
          position: "absolute",
          top: isMobile ? "10px" : "54px",
          right: isMobile ? "10px" : "50px",
          width: isMobile ? "62px" : "62px",
          height: "auto",
          zIndex: 1,
          display: isMobile ? "none" : "block", // Hide on mobile
        }}
      />

      {/* Decorative String Hand - Desktop Only */}
      <img
        src={Images.stringHand}
        alt="String Hand"
        style={{
          position: "absolute",
          top: "46%",
          left: "0px",
          width: "111px",
          height: "94px",
          zIndex: 1,
          display: isMobile ? "none" : "block", // Hide on mobile, show on desktop
          transform: "scaleX(-1)", // Invert horizontally
        }}
      />

      <img
        src={Images.donateLeftIcon1}
        alt="Orange Sparks"
        style={{
          position: "absolute",
          top: isMobile ? "10px" : "45%",
          right: isMobile ? "10px" : "50px",
          width: isMobile ? "19px" : "19px",
          height: "auto",
          zIndex: 1,
          display: isMobile ? "none" : "block", // Hide on mobile
        }}
      />

      <Box
        sx={{
            position:"absolute",
            top:"124px",
            left:"50%",
            width:"100%"
            ,transform:"translateX(-50%)",
        }}
      >
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: isMediumScreen ? "22px" : "28px",
            textAlign: "center",
            mb: isMobile ? 2 : "16px",
            textTransform: "capitalize",
            color: "#FFFFFF",
            maxWidth: "346px",
            mx: "auto",
            lineHeight: isMobile ? "28px" : "33px",
          }}
        >
          Small Donations Create Big Changes.
        </Typography>
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: isMediumScreen ? "12px" : "14px",
            textAlign: "center",
            mb: isMobile ? 2 : 4,
            color: "#EAEAEA",
            maxWidth:isMediumScreen?"332px": "432px",
            mx: "auto",
          }}
        >
          Small donations create big changes by turning simple acts of kindness
          into life-changing opportunities.
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <Box
          component="img"
          src={Images.donateLeftBanner}
          alt="Widow 1"
          sx={{
            width: isMobile ? "100%" : "100%",
            objectFit: "cover",
            borderRadius: "16px",
            boxShadow: 2,
          }}
        />
      </Box>
    </Box>
  );
};

export default DonateLeftBanner;
